export const convertDictData = (value: string) => {
  let dictData = { dict: 1 };
  try {
    if (!isNaN(parseInt(value))) {
      dictData = { dict: parseInt(value) };
    } else if (value !== "") dictData = JSON.parse(decodeURIComponent(value));
  } catch (error) {
    console.log("error dict:", error);
  }
  return dictData;
};
